<template>
    <div class="like" @click="likeClickEvent">
        <img v-if="isActive" :src="yesImg" :style="{width: heartWidth + 'px', height: heartHeight + 'px'}" />
        <img v-else :src="noImg" :style="{width: heartWidth + 'px', height: heartHeight + 'px'}" />
        <div :class="{count:true, active:isActive}" :style="fontStyle">{{ totalCount }}</div>
    </div>
</template>

<script>
    import * as ajax from "../../utils/ajax";
    import * as alert from '../../utils/alert';
    import * as biz from '../../utils/biz';

    export default {
        name: 'like',
        props: {
            interestDiv: String | Number,
            relatedNo: String |Number,
            heartWidth: {type: Number | String, default: 20},
            heartHeight: {type: Number | String, default: 18},
          yesImg:{
              type:String,
            default: "/assets/new/ic_heart_orange.png"
          },
          noImg:{
            type:String,
            default: "/assets/new/ic_heart_grey.png"
          },
          fontStyle:{
            type:String,
            default: ""
          },
          disabled:{
            type:Boolean,
            default:false,
          }
        },
        data() {
            return {
                isActive: false,
                totalCount: 0
            }
        },
        mounted() {
            this.refreshEvent();
        },
        methods: {
            refreshEvent() {
                ajax.Get(this, "/api/board/interest/" + this.interestDiv + "/" + this.relatedNo, function(ref, data) {
                    ref.totalCount = data.total_count;
                    ref.isActive = data.my_count > 0;
                });
            },
            likeClickEvent() {
                // 무한클릭을 방지하기 위해서 Login을 한 경우만 클릭가능
                if (!biz.isLogin(this)) {
                    alert.alertLogin(this);
                    return;
                }

                if(this.disabled)
                  return;

                const params = {
                    interest_div: this.interestDiv,
                    relation_no: this.relatedNo
                };
                ajax.Post(this, "/api/board/interest/", params, function(ref, data) {
                    ref.totalCount = data.total_count;
                    ref.isActive = data.my_count > 0;

                    if (ref.$listeners.click){
                      ref.$emit('click');
                      // ref.isActive = false;
                    }else{
                      if (ref.isActive) {
                        alert.alert("좋아요를 하셨습니다.", "확인");
                      } else {
                        alert.alert("좋아요가 해지되었습니다.", "확인");
                      }
                    }
                    ref.$emit('update:input', ref.isActive);
                });
            }
        },
        watch: {
            'relatedNo': function(val, oldVal) {
                this.refreshEvent();
            }
        }
    }
</script>

<style scoped lang="scss">
    div.like {
        display: flex;
        align-items: center;

        div.count {
            margin-left: 5px;
            font-size: $font-base16;
        }
      .active {
        color: $primary-color;
      }
    }
</style>
